import { render } from "./Prints.vue?vue&type=template&id=78c7e23d&scoped=true"
import script from "./Prints.vue?vue&type=script&lang=js"
export * from "./Prints.vue?vue&type=script&lang=js"

import "./Prints.vue?vue&type=style&index=0&id=78c7e23d&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Asus\\Desktop\\vue\\akpa\\akpa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78c7e23d"]])

export default __exports__